// extracted by mini-css-extract-plugin
export default {"activityTab":"Tab_activityTab__kwaB4","tabDesc":"Tab_tabDesc__Y7zAg"};